/**
 * M10 — live rooms. One live room or invite as a row: the counterpart's
 * first name (server-picked), its state, "open". More than one live →
 * "N rooms open" → the list. Never dismissable (class 1 when there is a
 * change, class 2 for invites).
 *
 * The tap is `open`; the host's route map turns `payload.screen` (the
 * MediationStack step) into the room's web step, or the catch-all that opens
 * the room where it currently is.
 */

import { MessageSquare } from 'react-feather';
import { HomeGlyph, HomeRow } from '../HomeKit';
import type { ModuleProps } from '../moduleTypes';

export function RoomsModule({ module, onAction }: ModuleProps) {
  if (module.type !== 'rooms') return null;
  const { payload } = module;
  const who = payload.counterpartName;

  let body: string;
  let sub: string;
  switch (payload.variant) {
    case 'replied':
      body = who ? `${who} replied` : 'They replied';
      sub = 'open to read it';
      break;
    case 'waiting':
      body = who ? `Waiting for ${who}` : 'Waiting for a reply';
      sub = 'you’ll hear when they reply';
      break;
    case 'invite':
      body = who ? `Invite from ${who}` : 'A room invite for you';
      sub = 'see what it’s about';
      break;
    case 'multi':
    default:
      body = `${payload.count} rooms open`;
      sub = 'open the list';
      break;
  }

  return (
    <HomeRow
      reason={module.reason}
      body={body}
      sub={sub}
      glyph={
        <HomeGlyph tone="magenta">
          <MessageSquare size={14} />
        </HomeGlyph>
      }
      dismissable={false}
      onOpen={() => onAction?.({ kind: 'open' }, module)}
    />
  );
}
